import { ReactComponent as IMG_BILIBILI } from '~/assets/images/social/bilibili.svg';
import { ReactComponent as IMG_DISCORD } from '~/assets/images/social/discord.svg';
import { ReactComponent as IMG_FACEBOOK } from '~/assets/images/social/facebook.svg';
import { ReactComponent as IMG_FORUM } from '~/assets/images/social/forum.svg';
import { ReactComponent as IMG_INSTAGRAM } from '~/assets/images/social/instagram.svg';
import { ReactComponent as IMG_NAVER_CAFE } from '~/assets/images/social/naver-cafe.svg';
import { ReactComponent as IMG_REDDIT } from '~/assets/images/social/reddit.svg';
import { ReactComponent as IMG_TIKTOK } from '~/assets/images/social/tiktok.svg';
import { ReactComponent as IMG_TWITTER } from '~/assets/images/social/twitter.svg';
import { ReactComponent as IMG_WEIBO } from '~/assets/images/social/weibo.svg';
import { ReactComponent as IMG_YOUTUBE } from '~/assets/images/social/youtube.svg';

import styled from '@emotion/styled';
import React from 'react';

import Link from '~/components/Link';
import { css } from '~/css';
import { SocialLink, SocialType } from '~/shared/contexts/frontmatter';
import { skin } from '~/theme';
import { rem } from 'polished';

interface SocialLinksProps {
  className?: string;
  socials: SocialLink[];
}

const Container = styled('div')(
  skin({
    blackSquare: css({
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: [rem(10), rem(20)],
      width: ['100%', 550],
      height: '100%',
      margin: '0 auto',
    }),
  }),
);

const IconLink = styled(Link)(
  skin({
    blackSquare: css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: [rem(44), rem(64)],
      lineHeight: 0,
      '> svg': {
        height: 'auto',
        overflow: 'hidden',
      },
    }),
  }),
);

const SocialLinks: React.FC<SocialLinksProps> = ({ className, socials }) => {
  return (
    <Container className={className}>
      {socials.map((social) => {
        const SocialIconSvg = iconMap[social.type];
        return (
          <IconLink key={social.type} to={social.url} className='social-link'>
            <SocialIconSvg />
          </IconLink>
        );
      })}
    </Container>
  );
};

export default SocialLinks;

const iconMap: { [key in SocialType]: React.FC } = {
  youtube: IMG_YOUTUBE,
  facebook: IMG_FACEBOOK,
  twitter: IMG_TWITTER,
  instagram: IMG_INSTAGRAM,
  reddit: IMG_REDDIT,
  forum: IMG_FORUM,
  navercafe: IMG_NAVER_CAFE,
  discord: IMG_DISCORD,
  weibo: IMG_WEIBO,
  bilibili: IMG_BILIBILI,
  tiktok: IMG_TIKTOK,
};
